var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSubTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1331_45999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06934 8.14C3.96392 8.14 3.86283 8.09813 3.78829 8.02359C3.71375 7.94905 3.67188 7.84795 3.67188 7.74254V0.397461C3.67188 0.292048 3.71375 0.190952 3.78829 0.116414C3.86283 0.0418752 3.96392 0 4.06934 0C4.17475 0 4.27584 0.0418752 4.35038 0.116414C4.42492 0.190952 4.4668 0.292048 4.4668 0.397461V7.74254C4.4668 7.84795 4.42492 7.94905 4.35038 8.02359C4.27584 8.09813 4.17475 8.14 4.06934 8.14Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74254 4.4668H0.397461C0.292048 4.4668 0.190952 4.42492 0.116414 4.35038C0.0418752 4.27584 0 4.17475 0 4.06934C0 3.96392 0.0418752 3.86283 0.116414 3.78829C0.190952 3.71375 0.292048 3.67188 0.397461 3.67188H7.74254C7.84795 3.67188 7.94905 3.71375 8.02359 3.78829C8.09813 3.86283 8.14 3.96392 8.14 4.06934C8.14 4.17475 8.09813 4.27584 8.02359 4.35038C7.94905 4.42492 7.84795 4.4668 7.74254 4.4668Z",
    fill: "#898989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSubTask);
export default __webpack_public_path__ + "static/media/AddSubTask.398cb031a76dd948b17a43eeca5616f0.svg";
export { ForwardRef as ReactComponent };